<template>
    <!-- <div class="window" v-if="isShow">
        <div style="margin: calc(100vw * 20 / 1920) 0 calc(100vw * 10 / 1920) calc(100vw * 20 / 1920);display: flex;flex: 7;font-size: calc(100vw * 16 / 1920);">{{text}}</div>
        <div style="display: flex;flex: 1; cursor: pointer;margin: calc(100vw * 4 / 1920);" @click="close">
            <svg t="1710740199927" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10982" width="calc(100vw * 22 / 1920)" height="calc(100vw * 22 / 1920)"><path d="M601.376 512l191.52-191.52c28.096-28.096 30.976-71.168 6.4-95.744s-67.68-21.696-95.744 6.4l-191.52 191.52-191.52-191.52c-28.096-28.096-71.168-30.976-95.744-6.368s-21.696 67.68 6.4 95.744l191.52 191.52-191.52 191.52c-28.096 28.096-30.976 71.168-6.368 95.744s67.68 21.696 95.744-6.4l191.52-191.52 191.52 191.52c28.096 28.096 71.168 30.976 95.744 6.4s21.696-67.68-6.4-95.744l-191.52-191.52z" :fill=" Global.globalColor" p-id="10983"></path></svg>
        </div>
    </div> -->
    <div  v-if="isShow">
      <div class="notification">
        <div class="d-flex jc-center" style="width: 100%;display: flex; justify-content: space-around;margin-top: 1%;">
          <dv-decoration-10 class="decoration-0" :color="['#fff','#fff']" />
          <div class="d-flex jc-center" style="display: flex; justify-content: space-around;width: 20%;">
            <h1 class="notification_title"><span v-for="item in maxRating" :key="item" :style="rating >= item ? 'color: #f0d759;' : 'color: #fff' ">★</span></h1>
          </div>
          <dv-decoration-10 class="decoration-1" :color="['#fff','#fff']"  />
        </div>
      <div class="notificationgroup">
        <div class="notification_content">
          {{text}}
        </div>
        <i class="notification_closeBtn" @click="close"><svg viewBox="0 0 1024 1024"  width="calc(100vw * 24 / 1920)" height="calc(100vw * 24 / 1920)" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path></svg></i>
      </div>
    </div>
    </div>
  </template>
  <script>
import { mapState } from "vuex";
  export default {
    data() {
      return {
        text: '系统错误，请联系管理员！',
        isShow: false,
        title: '标题',
        maxRating: 3,
        rating: 0,

      }
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow: (state) => state.user.chatShows,
        ChatValue: (state) => state.user.chatValue,
        BuissId: (state) => state.user.buissId,
      }),
    },
    watch: {
    ChatShow (val) {
      if (!isNaN(val)) {
        var buissId = this.BuissId
        if(buissId == undefined){
          buissId = 0
        }
        var caseID = localStorage.getItem("caseId")
        this.$http
          .get(
            "StudentData/GetOperateRate?operationID=" +
            this.ChatValue +
            "&caseID="+ caseID +
            "&round="+ this.Round + 
            "&buissId=" + buissId
          )
          .then((res) => {
            if (res.success) {
              if(res.dynamicObj.isShow){
                if(res.dynamicObj.operateExact == 100){
                  this.rating = 3
                } else if(res.dynamicObj.operateExact >= 50){
                  this.rating = 2
                }else if(res.dynamicObj.operateExact > 0){
                  this.rating = 1
                }
                if(res.dynamicObj.text != null || res.dynamicObj.text != ''){
                  this.text = res.dynamicObj.text
                }
                this.isShow = true   

              }
              // setTimeout(() => {
              //   this.isShow = false;
              // }, 3000);
            } else {
              return this.$message.error(res.message);
            }
          });
      }
    },
  },
    methods: {
      close(){
        this.isShow = false   
      }
    }
  }
  </script>
  <style scoped>
  .window {
    width: 100%;
    height: 100%;
    display: flex;
    border-radius: calc(100vw * 15 / 1920);
    box-shadow:  0px 0px 12px rgba(0, 0, 0, 0.12);
    background-color: white;
  }
  .notification{
    width: 100%;
    height: 100%;
    padding: calc(100vw * 12 / 1920) calc(100vw * 26 / 1920) calc(100vw * 8 / 1920) calc(100vw * 6 / 1920);
    border-radius:calc(100vw * 8 / 1920);
    box-sizing: border-box;
    border: calc(100vw * 1 / 1920) solid #ebeef5;
    background-color: #FF6B3D;
    box-shadow: 0px 0px calc(100vw * 12 / 1920) rgba(0, 0, 0, 0.12);
    transition: opacity 0.3s, transform 0.3s, left 0.3s, right 0.3s, top .4s, bottom 0.3s;
    overflow-wrap: anywhere;
    overflow-x: hidden;
    z-index: 9999;
    animation: slideInFromRight 1s ease forwards;
  }
  .notificationgroup{
    width: 100%;
    margin-left: calc(100vw * 8 / 1920);
    margin-right: calc(100vw * 8 / 1920);
  }
  .notification_title{
    font-weight: 700;
    font-size: calc(100vw * 32 / 1920);
    line-height: calc(100vw * 24 / 1920);
    color: #303133;
    margin: 0;
    text-align: center;
    display: flex;
  }
  .notification_content{
    font-size: calc(100vw * 18 / 1920);
    line-height: calc(100vw * 25 / 1920);
    margin: calc(100vw * 4 / 1920) 0 0;
    color: #fff;
    text-align: justify;
  }
  .notification_closeBtn{
    position: absolute;
    top: calc(100vw * 10 / 1920);
    right: calc(100vw * 10 / 1920);
    cursor: pointer;
    color: #fff;
  }
  .filled-star {
    color: #f0d759; /* 黄色 */
  }
  .decoration-0{
    width:28.3%;
    height:.1625rem;
  }
  .decoration-1{
    width:28.3%;
    height:.1625rem;
    transform: rotateY(180deg);
  }
  
/* 定义动画 */
@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
  </style>
